import React from "react";
import Card from "components/card";
import { Briefcase } from "lucide-react";
import GuideCard from "./GuideCard";
import { GUIDE_DATA } from "./GuideData";
import { LOCATION_THEMES } from "variables/constants";

const WorkforceGuide = ({ country }) => {
    
    if (!country) return <p className="p-4">Select a location to see details.</p>;
    const theme = LOCATION_THEMES[country.country];

    const countryGuide = GUIDE_DATA.find(g => g.country === country.country);
    if (!countryGuide) return <p className="p-4">No guide data available for this country.</p>;

    return (
        <Card className={`text-slate-900 flex flex-col gap-6 rounded-2xl border-2 shadow-xl overflow-hidden location-theme ${theme} bg border`}>
            <div className={`grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 pb-6 location-theme ${theme} bg-color text-white p-4 sm:p-6`}>
                <div className="flex items-center gap-3">
                    <div className="p-2 sm:p-3 rounded-xl bg-white/20 backdrop-blur-xl border border-white/30">
                        <Briefcase className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
                    </div>
                    <div>
                        <h4 className="text-[18px] sm:text-[22px] md:text-[24px]">
                            {country.country} — Detailed Country Workforce Guide
                        </h4>
                        <p className="text-blue-100 text-[12px] sm:text-[13px]">
                            Comprehensive employment and workforce insights
                        </p>
                    </div>
                </div>
            </div>
            <div className="pb-6 p-4 sm:p-6">
                <div className="space-y-6">
                    {countryGuide.guide.map((section, idx) => (
                        <GuideCard key={idx} section={section} theme={theme} />
                    ))}
                </div>
            </div>
        </Card>
    );
};

export default WorkforceGuide;
